import { array, InferType, number, object, string } from "yup";
import fetchRest from "../../../utils/fetchRest";
import { UserFeedRequestSchema } from "../types";

export interface GetUserFeedRequestsInput {
  feedId: string;
  data: {
    limit: number;
    skip: number;
    afterDate?: string;
    beforeDate?: string;
  };
}

const GetUserFeedRequestsOutputSchema = object({
  result: object()
    .shape({
      requests: array(UserFeedRequestSchema).required(),
      nextRetryAtIso: string().nullable().default(null),
      nextRetryReason: string()
        .oneOf(["REFRESH_RATE", "HOST_CACHE", "FAILED_RETRY_BACKOFF"])
        .nullable()
        .default(null),
      feedHostGlobalRateLimit: object({
        intervalSec: number().required(),
        requestLimit: number().required(),
      }).nullable(),
    })
    .required(),
}).required();

export type GetUserFeedRequestsOutput = InferType<typeof GetUserFeedRequestsOutputSchema>;

export const getUserFeedRequests = async ({
  feedId,
  data,
}: GetUserFeedRequestsInput): Promise<GetUserFeedRequestsOutput> => {
  const params = new URLSearchParams();

  params.append("limit", data.limit.toString());
  params.append("skip", data.skip.toString());

  if (data.afterDate) {
    params.append("afterDate", data.afterDate);
  }

  if (data.beforeDate) {
    params.append("beforeDate", data.beforeDate);
  }

  const query = params.toString();

  const res = await fetchRest(`/api/v1/user-feeds/${feedId}/requests?${query}`, {
    requestOptions: {
      method: "GET",
    },
    validateSchema: GetUserFeedRequestsOutputSchema,
  });

  return res as GetUserFeedRequestsOutput;
};
